"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var noneRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};

exports.default = noneRole;


//////////////////
// WEBPACK FOOTER
// ./node_modules/aria-query/lib/etc/roles/literal/noneRole.js
// module id = 842
// module chunks = 0